import type { RouteRecordRaw } from 'vue-router';
import { listRoute } from './list/list';
import { updateRoute } from './update/update';

// Register the static list path before the `:id` update route so it is not
// matched as a vendor id. Vendor creation is a dialog on the list page, not a
// route.
const childRoutes: RouteRecordRaw[] = [listRoute, updateRoute];

export default childRoutes;
